<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded || !loadedList">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content content--widget" v-if="loaded && type !== 'add'">
      <div class="widgets">
        <div class="widgets__row">
          <div class="widget">
            <div class="widget__title">
              Statistiky
            </div>
            <div class="widget__content">
              <div class="widget-row-wrap" v-for="year in years">
                <div class="widget-row">
                  <span class="widget-row__title">{{ year }}</span>
                </div>
                <div class="widget-row">
                  <span class="widget-row__number">{{
                    orders.filter((order) => order.year == year).length
                  }}</span
                  >prodaných kopií
                </div>
                <div class="widget-row">
                  <span class="widget-row__number"
                    >{{
                      sumPrice(
                        orders.filter((order) => order.year == year)
                      ).toFixed(2)
                    }}
                    Kč<span class="widget-number-sub"
                      >({{
                        (
                          sumPrice(
                            orders.filter((order) => order.year == year)
                          ) -
                          (sumPrice(
                            orders.filter((order) => order.year == year)
                          ) /
                            100) *
                            10
                        ).toFixed(2)
                      }}
                      Kč bez DPH)</span
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-if="loaded">
      <h1 v-if="type === 'add'">
        Vytváření audioknihy
      </h1>
      <h1 v-else>
        Detail audioknihy
      </h1>

      <v-layout>
        <table class="info-table">
          <tr>
            <td class="info-table__title">
              Výhodný set:
            </td>
            <td class="info-table__value">
              <div
                v-for="state in states.filter(
                  (stateItem) => stateItem.id === 9
                )"
              >
                <v-checkbox
                  :label="state.name"
                  class="input--smaller"
                  outlined
                  :value="state.id"
                  v-model="data.states"
                  @change="handleChangeToSet($event)"
                >
                </v-checkbox>
              </div>
              <div v-if="errorSet" class="error--text">
                {{ errorSet }}
              </div>
            </td>
          </tr>

          <!-- Tištěné a e-knihy -->

          <tr>
            <td class="info-table__title">
              E-kniha:
            </td>
            <td class="info-table__value">
              <div>
                <v-checkbox
                  label="E-kniha"
                  class="input--smaller"
                  outlined
                  v-model="isEbook"
                >
                </v-checkbox>
              </div>
              <div v-if="errorSet" class="error--text">
                {{ errorSet }}
              </div>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Tištěná kniha:
            </td>
            <td class="info-table__value">
              <div>
                <v-checkbox
                  label="Tištěná kniha"
                  class="input--smaller"
                  outlined
                  v-model="isBook"
                >
                </v-checkbox>
              </div>
              <div v-if="errorSet" class="error--text">
                {{ errorSet }}
              </div>
            </td>
          </tr>

          <tr v-if="data.states.find((stateItem) => stateItem === 9)">
            <td class="info-table__title">
              Knihy v setu:
            </td>
            <td class="info-table__value" v-if="displaySets">
              <div
                class="info-table-value-flex"
                v-for="(set, index) in data.set_books"
              >
                <!--:items="audiobooks" -->
                <v-autocomplete
                  :items="products"
                  v-model="data.set_books[index]"
                  outlined
                  item-value="id"
                  item-text="name"
                  class="input--small"
                  @change="$forceUpdate(), changeSetBook(index)"
                ></v-autocomplete>
                <v-text-field
                  v-if="data.set_books_price[index]"
                  class="input--smallest input--price-set"
                  type="number"
                  @keypress="onlyNumber"
                  outlined
                  v-model="data.set_books_price[index].price"
                  @input="recountSetBookPrice()"
                >
                </v-text-field>
                <!-- eura -->
                <v-text-field
                  label="Eur"
                  v-if="data.set_books_price[index]"
                  class="input--smallest input--price-set"
                  type="number"
                  outlined
                  v-model="data.set_books_price[index].price_eur"
                  @input="recountSetBookPrice()"
                ></v-text-field>
                <v-btn
                  color="error"
                  type="submit"
                  class="button--inputs"
                  @click="removeSet(index)"
                >
                  odebrat
                </v-btn>
              </div>
              <v-btn
                color="secondary"
                type="submit"
                class="button--inputs"
                @click="addSet()"
              >
                + Přidat knihu
              </v-btn>
            </td>
          </tr>
          <tr v-if="type !== 'add'">
            <td class="info-table__title">
              URL
            </td>
            <td class="info-table__value info-table__value--text">
              <a target="_blank" :href="data.url">{{ data.url }}</a>
            </td>
          </tr>

          <tr
            v-if="
              data.states.find((stateItem) => stateItem === 9) &&
                data.set_books.length < 6
            "
          >
            <td class="info-table__title">
              Náhledový obrázek:<br />
              <span>(Pokud není vybrán obrázek níže)</span>
            </td>
            <td class="info-table__value">
              <div>
                <div
                  class="image image--set"
                  v-bind:class="[
                    { 'image--empty': data.set_books.length === 0 },
                    { 'image--set-1': data.set_books.length === 1 },
                    { 'image--set-2': data.set_books.length === 2 },
                    { 'image--set-3': data.set_books.length === 3 },
                    { 'image--set-4': data.set_books.length === 4 },
                    { 'image--set-5': data.set_books.length === 5 },
                  ]"
                >
                  <div class="tag">
                    Výhodný set
                  </div>
                  <div class="image-sets" v-if="data.set_books.length > 0">
                    <div class="set-wrap" v-for="set in data.set_books">
                      <div
                        class="image__set"
                        v-if="
                          set &&
                            audiobooks.find((audiobook) => audiobook.id === set)
                        "
                        :style="
                          'background-image:url(' +
                            audiobooks.find((audiobook) => audiobook.id === set)
                              .image +
                            ')'
                        "
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            v-if="
              !data.states.find((stateItem) => stateItem === 9) ||
                data.states.find((stateItem) => stateItem === 9)
            "
          >
            <td class="info-table__title">
              Náhledový obrázek:<br />
              <span v-if="data.states.find((stateItem) => stateItem === 9)"
                >(Nahradí obrázky setu tímto obrázkem)</span
              >
            </td>
            <td class="info-table__value">
              <div
                v-if="!exampleUpladed || !exampleLongUpladed"
                class="input-loader--something"
              >
                <div class="image image--loader">
                  <div class="loader">
                    <div class="loader__item"></div>
                    <div class="loader__text">Něco se nahrává</div>
                  </div>
                </div>
              </div>
              <div v-else-if="!imageUploaded">
                <div class="image image--loader">
                  <div class="loader">
                    <div class="loader__item"></div>
                    <div class="loader__text">Nahrávání</div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="image image--data"
                  v-if="data.image"
                  :style="'background-image:url(' + data.image + ')'"
                >
                  <div
                    class="tag"
                    v-if="data.states.find((stateItem) => stateItem === 9)"
                  >
                    Výhodný set
                  </div>
                </div>
                <div class="image image--empty" v-else>
                  <div
                    class="tag"
                    v-if="data.states.find((stateItem) => stateItem === 9)"
                  >
                    Výhodný set
                  </div>
                </div>
              </div>

              <div
                class="image-controls"
                v-if="exampleUpladed && exampleLongUpladed && imageUploaded"
              >
                <v-btn
                  @click="selectCoverImage()"
                  v-if="!data.image"
                  color="primary"
                  type="submit"
                  class="button--inputs"
                >
                  Vybrat
                </v-btn>

                <v-btn
                  @click="selectCoverImage()"
                  v-if="data.image"
                  color="secondary"
                  type="submit"
                  class="button--inputs"
                >
                  Vybrat jiný
                </v-btn>
                <v-btn
                  @click="removeCoverImage()"
                  v-if="data.image"
                  color="error"
                  type="submit"
                  class="button--inputs"
                >
                  Smazat
                </v-btn>
              </div>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Alt
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--largest"
                outlined
                v-model="data.image_alt"
                @input="errors.image_alt = ''"
                :error-messages="makeError(errors.image_alt)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="type !== 'add'">
            <td class="info-table__title">
              ID:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="data.id"
                @input="errors.id = ''"
                :error-messages="makeError(errors.id)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Název: <span class="required-symbol">*</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--larger"
                outlined
                v-model="data.name"
                @input="errors.name = ''"
                :error-messages="makeError(errors.name)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="isBook || isEbook">
            <td class="info-table__title">
              Originální název: <span class="required-symbol"></span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--larger"
                outlined
                v-model="data.original_name"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Jazyk: <span class="required-symbol">*</span>
            </td>
            <td class="info-table__value">
              <v-select
                :items="langTypes"
                :error-messages="makeError(errors.lang)"
                v-model="data.lang"
                outlined
                @select="errors.lang = ''"
                item-value="type"
                item-text="text"
                class="input--small"
              ></v-select>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Podtitul:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--large"
                outlined
                v-model="data.name_sub"
                @input="errors.name_sub = ''"
                :error-messages="makeError(errors.name_sub)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Pořadí:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--smaller"
                outlined
                type="number"
                v-model="data.sort_order"
                @input="errors.sort_order = ''"
                :error-messages="makeError(errors.sort_order)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Slug: <span class="required-symbol">*</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="data.slug"
                @input="errors.slug = ''"
                :error-messages="makeError(errors.slug)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              GTIN:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                type="number"
                outlined
                @keypress="onlyNumber"
                v-model="data.gtin"
                @input="errors.gtin = ''"
                :error-messages="makeError(errors.gtin)"
              >
              </v-text-field>
            </td>
          </tr>
          <!-- v-if="!isBook && !isEbook" -->
          <tr>
            <td class="info-table__title">
              Popis feed:
            </td>
            <td class="info-table__value">
              <v-textarea
                class="input--largeer"
                outlined
                @input="errors.description_app = ''"
                v-model="data.description_app"
                :error-messages="makeError(errors.description_app)"
              >
              </v-textarea>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Popis: <span class="required-symbol">*</span>
            </td>
            <td class="info-table__value">
              <tiptap-vuetify
                class="wysiwyg"
                v-bind:class="{ 'wysiwyg--error': errors.description }"
                @input="errors.description = ''"
                v-model="data.description"
                :extensions="extensions"
              />
              <div
                v-if="errors.description"
                class="v-messages theme--light error--text error--wysiwyg-text"
              >
                <span>{{ makeError(errors.description) }}</span>
              </div>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Z audioknihy:
            </td>
            <td class="info-table__value">
              <tiptap-vuetify
                class="wysiwyg wysiwyg--from-book"
                v-bind:class="{ 'wysiwyg--error': errors.description_book }"
                @input="errors.description_book = ''"
                v-model="data.description_book"
                :extensions="extensions"
              />
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Kapitoly:
            </td>
            <td
              class="info-table__value info-table__value--chapters"
              v-if="displayChapters"
            >
              <div class="chapters" v-for="(chapter, index) in data.chapters">
                <span
                  class="chapters__number"
                  v-if="(index + 1).toString().length === 1"
                >
                  0{{ index + 1 }}
                </span>
                <span class="chapters__number" v-else>
                  {{ index + 1 }}
                </span>
                <v-text-field
                  v-model="data.chapters[index]"
                  outlined
                  class="input--larger input--chapter"
                ></v-text-field>
                <v-btn
                  color="error"
                  type="submit"
                  class="button--inputs"
                  @click="removeChapter(index)"
                >
                  odebrat
                </v-btn>
              </div>
              <v-btn
                color="secondary"
                type="submit"
                class="button--inputs"
                @click="addChapter()"
              >
                + Přidat kapitolu
              </v-btn>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Autor:
            </td>
            <td class="info-table__value">
              <v-autocomplete
                v-model="data.author_id"
                :items="authors"
                :menu-props="{ maxHeight: '400' }"
                multiple
                :error-messages="makeError(errors.author_id)"
                item-value="id"
                @select="errors.author_id = ''"
                item-text="name"
                outlined
                class="input--larger"
                persistent-hint
              ></v-autocomplete>
            </td>
          </tr>

          <tr v-if="!isBook && !isEbook">
            <td class="info-table__title">
              Interpret:
            </td>
            <td class="info-table__value">
              <v-autocomplete
                v-model="data.interpret_id"
                :items="interprets"
                :menu-props="{ maxHeight: '400' }"
                multiple
                :error-messages="makeError(errors.interpret_id)"
                item-value="id"
                @select="errors.interpret_id = ''"
                item-text="name"
                outlined
                class="input--larger"
                persistent-hint
              ></v-autocomplete>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Majitel licence:
            </td>
            <td class="info-table__value">
              <v-autocomplete
                :items="publishers.filter((publisher) => publisher.licence)"
                :error-messages="makeError(errors.publisher_licence_id)"
                v-model="data.publisher_licence_id"
                outlined
                @select="errors.publisher_licence_id = ''"
                item-value="id"
                item-text="name"
                class="input--small"
              ></v-autocomplete>
            </td>
          </tr>

          <tr v-if="data.publisher_licence_id">
            <td class="info-table__title">
              Provize maitele licence:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.publisher_provision"
                @input="errors.publisher_provision = ''"
                :error-messages="makeError(errors.publisher_provision)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Vydavatel:
            </td>
            <td class="info-table__value">
              <v-autocomplete
                :items="publishers.filter((publisher) => !publisher.licence)"
                :error-messages="makeError(errors.publisher_id)"
                v-model="data.publisher_id"
                outlined
                @select="errors.publisher_id = ''"
                item-value="id"
                item-text="name"
                class="input--small"
              ></v-autocomplete>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Kategorie: <span class="required-symbol">*</span>
            </td>
            <td class="info-table__value" v-if="displayCategories">
              <div
                class="info-table-value-flex"
                v-for="(category, index) in data.categories"
              >
                <v-autocomplete
                  :items="categories"
                  v-model="data.categories[index]"
                  outlined
                  item-value="id"
                  item-text="name"
                  class="input--small"
                ></v-autocomplete>
                <v-btn
                  color="error"
                  type="submit"
                  class="button--inputs"
                  @click="removeCategory(index)"
                >
                  odebrat
                </v-btn>
              </div>
              <v-btn
                color="secondary"
                type="submit"
                class="button--inputs"
                @click="addCategory()"
              >
                + Přidat kategorii
              </v-btn>

              <div v-if="errorCategories" class="error--text">
                {{ errorCategories }}
              </div>
            </td>
          </tr>

          <tr v-if="!isBook && !isEbook">
            <td class="info-table__title">Délka:<br /><span>(min)</span></td>
            <td
              class="info-table__value"
              v-if="data.states.find((stateItem) => stateItem === 9)"
            >
              <!-- disabled -->
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.length"
                @input="errors.length = ''"
                :error-messages="makeError(errors.length)"
              >
              </v-text-field>
            </td>
            <td v-else class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.length"
                @input="errors.length = ''"
                :error-messages="makeError(errors.length)"
              >
              </v-text-field>
            </td>
          </tr>

          <!-- Počet stran -->
          <tr v-if="isBook || isEbook">
            <td class="info-table__title">Počet stran:<br /><span></span></td>
            <td class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.pages"
                @input="errors.pages = ''"
                :error-messages="makeError(errors.pages)"
              >
              </v-text-field>
            </td>
          </tr>
          <!-- Počet stran -->
          <tr v-if="isBook || isEbook">
            <td class="info-table__title">
              Datum vydání:<br /><span>(DD-MM-YYYY)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="data.published_at"
                @input="errors.published_at = ''"
                :error-messages="makeError(errors.published_at)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr v-if="!isBook && !isEbook">
            <td class="info-table__title">Velikost:<br /><span>(MB)</span></td>
            <td
              class="info-table__value"
              v-if="data.states.find((stateItem) => stateItem === 9)"
            >
              <!-- disabled -->
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.size"
                @input="errors.size = ''"
                :error-messages="makeError(errors.size)"
              >
              </v-text-field>
            </td>
            <td v-else class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.size"
                @input="errors.size = ''"
                :error-messages="makeError(errors.size)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr v-if="!isEbook && !isBook">
            <td class="info-table__title">
              Velikost Api:<br /><span>(MB)</span>
            </td>
            <td
              class="info-table__value"
              v-if="data.states.find((stateItem) => stateItem === 9)"
            >
              <!-- disabled -->
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.size_api"
                @input="errors.size_api = ''"
                :error-messages="makeError(errors.size_api)"
              >
              </v-text-field>
            </td>
            <td v-else class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.size_api"
                @input="errors.size_api = ''"
                :error-messages="makeError(errors.size_api)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr
            v-if="
              !isEbook &&
                !isBook &&
                data.states.find((stateItem) => stateItem === 9)
            "
          >
            <td class="info-table__title">Synchronizovat velikosti:<br /></td>
            <td class="info-table__value">
              <v-btn
                color="secondary"
                type="submit"
                class="button--inputs"
                @click="recountSetData"
              >
                Synchronizovat
              </v-btn>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Formát:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="data.format"
                @input="errors.format = ''"
                :error-messages="makeError(errors.format)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Cena: <span class="required-symbol">*</span><br /><span
                >(Kč)</span
              >
            </td>
            <td
              class="info-table__value"
              v-if="data.states.find((stateItem) => stateItem === 9)"
            >
              <v-text-field
                class="input--smaller"
                type="text"
                outlined
                disabled
                v-model="data.price"
                :error-messages="makeError(errors.price)"
              >
              </v-text-field>
            </td>
            <td class="info-table__value" v-else>
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.price"
                @input="errors.price = ''"
                :error-messages="makeError(errors.price)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Cena: <span class="required-symbol">*</span><br /><span
                >(Eur)</span
              >
            </td>
            <td
              class="info-table__value"
              v-if="data.states.find((stateItem) => stateItem === 9)"
            >
              <v-text-field
                class="input--smaller"
                type="text"
                outlined
                disabled
                v-model="data.price_eur"
                @blur="toFloat(data.price_eur, 'price_eur')"
                :error-messages="makeError(errors.price)"
              >
              </v-text-field>
            </td>
            <td class="info-table__value" v-else>
              <v-text-field
                class="input--smaller"
                type="number"
                outlined
                v-model="data.price_eur"
                @input="errors.price = ''"
                @blur="toFloat(data.price_eur, 'price_eur')"
                :error-messages="makeError(errors.price)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Cena v iOS appce:
              <br /><span>(Kč)</span>
            </td>

            <td class="info-table__value">
              <v-autocomplete
                :items="iosProductIds"
                v-model="data.ios_product_id"
                outlined
                item-value="ios_product_id"
                item-text="price"
                class="input--small"
              ></v-autocomplete>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Stavy:
            </td>
            <td
              class="info-table__value"
              v-if="data.states.find((stateItem) => stateItem === 9)"
            >
              <div
                v-for="state in states.filter(
                  (stateItem) =>
                    stateItem.id !== 9 &&
                    stateItem.id !== 8 &&
                    stateItem.id !== 2
                )"
              >
                <v-checkbox
                  :label="state.name"
                  class="input--smaller"
                  outlined
                  :value="state.id"
                  v-model="data.states"
                  @change="$forceUpdate()"
                >
                </v-checkbox>
              </div>
            </td>
            <td class="info-table__value" v-else>
              <div
                v-for="state in states.filter(
                  (stateItem) => stateItem.id !== 9
                )"
              >
                <v-checkbox
                  :label="state.name"
                  class="input--smaller"
                  outlined
                  :value="state.id"
                  v-model="data.states"
                >
                </v-checkbox>
              </div>
            </td>
          </tr>

          <tr v-if="data.states.find((state) => state === 4)">
            <td class="info-table__title">
              Připravujeme:
            </td>
            <td class="info-table__value info-table__value--date">
              <v-text-field
                class="input--small"
                outlined
                disabled
                v-model="datePreparing"
                @input="errors.preparing_date = ''"
                :error-messages="makeError(errors.preparing_date)"
              >
              </v-text-field>

              <v-btn
                color="secondary"
                type="submit"
                class="button--table"
                @click="openDialogDatePreparing()"
              >
                Změnit
              </v-btn>
              <v-btn
                color="error"
                type="submit"
                class="button--table"
                @click="data.preparing_date = null"
              >
                Zrušit
              </v-btn>
            </td>
          </tr>

          <tr v-if="data.states.find((state) => state === 2)">
            <td class="info-table__title">
              Cena v akci:<br /><span>(Kč)</span>
            </td>
            <td
              class="info-table__value"
              v-if="data.states.find((stateItem) => stateItem === 9)"
            >
              <v-text-field
                class="input--smaller"
                type="text"
                @keypress="onlyNumber"
                outlined
                disabled
                v-model="data.price_discount"
                :error-messages="makeError(errors.price_discount)"
              >
              </v-text-field>
            </td>
            <td class="info-table__value" v-else>
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.price_discount"
                @input="errors.price_discount = ''"
                :error-messages="makeError(errors.price_discount)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="data.states.find((state) => state === 2)">
            <td class="info-table__title">
              Cena v akci:<br /><span>(Eur)</span>
            </td>
            <td
              class="info-table__value"
              v-if="data.states.find((stateItem) => stateItem === 9)"
            >
              <v-text-field
                class="input--smaller"
                type="text"
                outlined
                disabled
                v-model="data.price_discount_eur"
                @blur="toFloat(data.price_discount_eur, 'price_discount_eur')"
                :error-messages="makeError(errors.price_discount)"
              >
              </v-text-field>
            </td>
            <td class="info-table__value" v-else>
              <v-text-field
                class="input--smaller"
                type="number"
                outlined
                v-model="data.price_discount_eur"
                @input="errors.price_discount = ''"
                @blur="toFloat(data.price_discount_eur, 'price_discount_eur')"
                :error-messages="makeError(errors.price_discount)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr
            v-if="
              data.states.find((state) => state === 2) &&
                !data.states.find((stateItem) => stateItem === 9)
            "
          >
            <td class="info-table__title">
              Akce od:
            </td>
            <td class="info-table__value info-table__value--date">
              <v-text-field
                class="input--small"
                outlined
                disabled
                v-model="dateFrom"
                @input="errors.price_discount_from = ''"
                :error-messages="makeError(errors.price_discount_from)"
              >
              </v-text-field>

              <v-btn
                color="secondary"
                type="submit"
                class="button--table"
                @click="openDialogDateFrom()"
              >
                Změnit
              </v-btn>
              <v-btn
                color="error"
                type="submit"
                class="button--table"
                @click="
                  data.price_discount_from = null;
                  data.price_discount_from_date = null;
                  data.price_discount_from_time = null;
                "
              >
                Zrušit
              </v-btn>
            </td>
          </tr>
          <tr
            v-if="
              data.states.find((state) => state === 2) &&
                !data.states.find((stateItem) => stateItem === 9)
            "
          >
            <td class="info-table__title">
              Akce do:
            </td>
            <td class="info-table__value info-table__value--date">
              <v-text-field
                class="input--small"
                outlined
                disabled
                v-model="dateTo"
                @input="errors.price_discount_to = ''"
                :error-messages="makeError(errors.price_discount_to)"
              >
              </v-text-field>

              <v-btn
                color="secondary"
                type="submit"
                class="button--table"
                @click="openDialogDateTo()"
              >
                Změnit
              </v-btn>
              <v-btn
                color="error"
                type="submit"
                class="button--table"
                @click="
                  data.price_discount_to = null;
                  data.price_discount_to_date = null;
                  data.price_discount_to_time = null;
                "
              >
                Zrušit
              </v-btn>
            </td>
          </tr>

          <tr>
            <td class="info-table__title"></td>
            <td class="info-table__value">
              <v-checkbox
                label="Předprodej"
                class="input--smaller"
                outlined
                v-model="data.presale"
              >
              </v-checkbox>
            </td>
          </tr>
          <tr v-if="data.presale">
            <td class="info-table__title">
              Cena v předprodeji (Kč)
            </td>
            <td class="info-table__value">
              <v-text-field
                outlined
                class="input--smaller"
                type="number"
                v-model="data.presale_price"
              />
            </td>
          </tr>
          <tr v-if="data.presale">
            <td class="info-table__title">
              Cena v předprodeji (€)
            </td>
            <td class="info-table__value">
              <v-text-field
                outlined
                class="input--smaller"
                type="number"
                v-model="data.presale_price_eur"
              />
            </td>
          </tr>
          <tr v-if="!isEbook && !isBook">
            <td class="info-table__title">Příklad:<br /><span>(mp3)</span></td>
            <td class="info-table__value">
              <div v-if="!exampleUpladed" class="input-loader">
                <div class="loader loader--input">
                  <div class="loader__item"></div>
                  <div class="loader__text">Nahrávání</div>
                </div>
              </div>
              <div
                v-else-if="!exampleLongUpladed || !imageUploaded"
                class="input-loader input-loader--something"
              >
                <div class="loader loader--input">
                  <div class="loader__item"></div>
                  <div class="loader__text">Něco se nahrává</div>
                </div>
              </div>
              <div v-else>
                <v-btn
                  v-if="!data.example_name"
                  color="primary"
                  type="submit"
                  class="button--inputs"
                  @click="selectExample()"
                >
                  Vybrat .mp3
                </v-btn>

                <div class="mp3-example" v-else>
                  <span class="mp3-example__name">{{ data.example_name }}</span>

                  <v-btn
                    color="primary"
                    type="submit"
                    class="button--play"
                    @click="playPauseExample(data.example_url)"
                  >
                    <span
                      class="triangle-play"
                      v-bind:class="{
                        'triangle-play--playing': exampleIsPlaying,
                      }"
                    ></span>
                  </v-btn>
                  <br />
                  <v-btn
                    color="secondary"
                    type="submit"
                    class="button--inputs"
                    @click="selectExample()"
                  >
                    Vybrat novou .mp3
                  </v-btn>
                  <v-btn
                    color="error"
                    type="submit"
                    class="button--inputs button--last"
                    @click="removeExample()"
                  >
                    Smazat
                  </v-btn>
                </div>
              </div>
            </td>
          </tr>

          <tr v-if="data.example_name">
            <td class="info-table__title">
              Délka příkladu:<br /><span>(min)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.example_length"
                @input="errors.example_length = ''"
                :error-messages="makeError(errors.example_length)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr v-if="!isEbook && !isBook">
            <td class="info-table__title">
              Delší příklad (mp3):
            </td>
            <td class="info-table__value">
              <div v-if="!exampleLongUpladed" class="input-loader">
                <div class="loader loader--input">
                  <div class="loader__item"></div>
                  <div class="loader__text">Nahrávání</div>
                </div>
              </div>
              <div
                v-else-if="!exampleUpladed || !imageUploaded"
                class="input-loader  input-loader--something"
              >
                <div class="loader loader--input">
                  <div class="loader__item"></div>
                  <div class="loader__text">Něco se nahrává</div>
                </div>
              </div>
              <div v-else>
                <v-btn
                  v-if="!data.example_long_name"
                  color="primary"
                  type="submit"
                  class="button--inputs"
                  @click="selectExampleLong()"
                >
                  Vybrat .mp3
                </v-btn>

                <div class="mp3-example" v-else>
                  <span class="mp3-example__name">{{
                    data.example_long_name
                  }}</span>
                  <v-btn
                    color="primary"
                    type="submit"
                    class="button--play"
                    @click="playPauseExampleLong(data.example_long_url)"
                  >
                    <span
                      class="triangle-play"
                      v-bind:class="{
                        'triangle-play--playing': exampleLongIsPlaying,
                      }"
                    ></span>
                  </v-btn>
                  <br />
                  <v-btn
                    color="secondary"
                    type="submit"
                    class="button--inputs"
                    @click="selectExampleLong()"
                  >
                    Vybrat novou .mp3
                  </v-btn>
                  <v-btn
                    color="error"
                    type="submit"
                    class="button--inputs  button--last"
                    @click="removeExampleLong()"
                  >
                    Smazat
                  </v-btn>
                </div>
              </div>
            </td>
          </tr>

          <tr v-if="data.example_long_name">
            <td class="info-table__title">
              Délka delšího příkladu:<br /><span>(min)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.example_long_length"
                @input="errors.example_long_length = ''"
                :error-messages="makeError(errors.example_long_length)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <!-- v-if="isEbook || isBook" -->
            <td class="info-table__title">Doplňkové materiály</td>
            <td class="info-table__value">
              <input
                type="file"
                ref="inputAdditionalFiles"
                style="display:none"
                @input="handleUploadAdditionalFiles($event.target.files[0])"
              />
              <v-btn
                @click="$refs.inputAdditionalFiles.click()"
                color="primary"
                type="submit"
                class="button--inputs mr-2"
                :loading="additionalFilesPathLoading"
              >
                Nahrát
              </v-btn>
              <a
                v-if="additionalFilesPathFull"
                :href="additionalFilesPathFull"
                target="_blank"
                >Soubor</a
              >
              <v-btn
                class="button--inputs ml-4"
                v-if="additionalFilesPathFull"
                @click="
                  (additionalFilesPathFull = null), (additionalFilesPath = null)
                "
                color="error"
                type="submit"
              >
                Smazat
              </v-btn>
            </td>
          </tr>
          <!-- v-if="isEbook || isBook" -->
          <tr>
            <td class="info-table__title">Presskit materiály</td>
            <td class="info-table__value">
              <input
                type="file"
                ref="inputAdditionalFilesPresskit"
                style="display:none"
                @input="
                  handleUploadAdditionalFiles(
                    $event.target.files[0],
                    'additionoalFilesPresskitPath'
                  )
                "
              />
              <v-btn
                @click="$refs.inputAdditionalFilesPresskit.click()"
                color="primary"
                type="submit"
                class="button--inputs mr-2"
                :loading="additionoalFilesPresskitPathLoading"
              >
                Nahrát
              </v-btn>
              <a
                v-if="additionoalFilesPresskitPathFull"
                :href="additionoalFilesPresskitPathFull"
                target="_blank"
                >Soubor</a
              >
              <v-btn
                class="button--inputs ml-4"
                v-if="additionoalFilesPresskitPathFull"
                @click="
                  (additionoalFilesPresskitPathFull = null),
                    (additionoalFilesPresskitPath = null)
                "
                color="error"
              >
                Smazat
              </v-btn>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Publikováno datum:<br /><span>(DD-MM-YYYY)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                v-model="data.publish_date"
                @input="errors.publish_date = ''"
                :error-messages="makeError(errors.publish_date)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Publikováno:
            </td>
            <td class="info-table__value">
              <v-checkbox
                class="input--smaller"
                outlined
                v-model="data.published"
                @input="errors.published = ''"
                :error-messages="makeError(errors.published)"
              >
              </v-checkbox>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Neprodejné (licence skončila):
            </td>
            <td class="info-table__value">
              <v-checkbox
                class="input--smaller"
                outlined
                v-model="data.view_only"
                @input="errors.view_only = ''"
                :error-messages="makeError(errors.view_only)"
              >
              </v-checkbox>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Podobné audioknihy:
            </td>
            <td class="info-table__value">
              <v-autocomplete
                v-model="data.similar"
                :items="audiobooks"
                :menu-props="{ maxHeight: '400' }"
                multiple
                :error-messages="makeError(errors.audiobooks)"
                item-value="id"
                @select="errors.audiobooks = ''"
                item-text="name"
                outlined
                class="input--larger input--multiselect"
                persistent-hint
              ></v-autocomplete>
            </td>
          </tr>
        </table>
      </v-layout>
      <h2>SEO</h2>
      <v-layout>
        <table class="info-table">
          <tr>
            <td class="info-table__title">
              Titulek:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                @input="errors.seo_title = ''"
                v-model="data.seo_title"
                :error-messages="makeError(errors.seo_title)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Popis:
            </td>
            <td class="info-table__value">
              <v-textarea
                class="input--larger"
                outlined
                @input="errors.seo_meta = ''"
                v-model="data.seo_meta"
                :error-messages="makeError(errors.seo_meta)"
              >
              </v-textarea>
            </td>
          </tr>
        </table>
      </v-layout>
      <v-layout>
        <div class="controls-table">
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="addAudiobook()"
            v-if="type === 'add'"
          >
            Vytvořit
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="editAudiobook()"
            v-else
          >
            Uložit
          </v-btn>
          <v-btn
            color="error"
            class="button--control"
            @click="openDialogDelete()"
            v-if="type !== 'add'"
          >
            Smazat
          </v-btn>
          <v-btn
            color="secondary"
            @click="generateAppCopy"
            :loading="generateCopyRequest"
            :disabled="['not', 'preparing'].includes(data.prepared_status)"
            v-if="type !== 'add'"
            >Generovat pro aplikace</v-btn
          >
        </div>
      </v-layout>

      <h2 v-if="type !== 'add'">Recenze knihy</h2>
      <v-layout v-if="type !== 'add'">
        <div>
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="openDialogReviewCreate()"
          >
            Přidat recenzi
          </v-btn>
        </div>
      </v-layout>
      <v-layout v-if="type !== 'add'">
        <div>
          <div class="review-card" v-for="review in data.reviews">
            <div class="review__user">
              <b>Uživatel:</b> {{ review.user_forename }}
              {{ review.user_surname }} - {{ review.user_email }}
            </div>
            <div class="review__user"><b>Jméno:</b> {{ review.name }}</div>
            <div class="review__stars">
              <b>Počet hvězd:</b> {{ review.rating }}
            </div>
            <div class="review__user">
              <b>Recenze z:</b> {{ review.review_from }}
            </div>
            <div class="review__user">
              <b>Datum recenze:</b> {{ review.review_date_cz }}
            </div>
            <div class="review__text"><b>Text:</b> {{ review.review }}</div>
            <div class="controls-table">
              <v-btn
                color="secondary"
                type="submit"
                class="button--control"
                @click="openDialogReviewUpdate(review)"
              >
                upravit
              </v-btn>
              <v-btn
                color="error"
                class="button--control"
                @click="openDialogReviewDelete(review)"
              >
                Smazat
              </v-btn>
            </div>
          </div>
        </div>
      </v-layout>

      <v-dialog v-model="dialogReview" persistent>
        <v-card>
          <v-card-title class="headline">Recenze</v-card-title>
          <v-card-text v-if="reviewData.type == 'delete'">
            Opravdu si přejete smazat recenzi od
            <strong>{{ reviewData.nameOriginal }}</strong
            >?
          </v-card-text>
          <v-card-text v-if="reviewData.type == 'create'">
            Vyplňte data k recenzi.
          </v-card-text>
          <v-card-text v-if="reviewData.type == 'update'">
            Upravte data k recenzi od
            <strong>{{ reviewData.nameOriginal }}</strong
            >.
          </v-card-text>
          <v-card-text
            v-if="reviewData.type == 'create' || reviewData.type == 'update'"
          >
            <table class="info-table">
              <tr>
                <td class="info-table__title" style="text-align: left">
                  Jméno* :
                </td>
                <td class="info-table__value">
                  <v-text-field
                    :class="[
                      { 'input--error': reviewErrors.includes('review_name') },
                    ]"
                    class="input--small"
                    outlined
                    v-model="reviewData.name"
                    @input="removeErrorReview('review_name')"
                  >
                  </v-text-field>
                </td>
              </tr>
              <tr>
                <td class="info-table__title" style="text-align: left">
                  Počet hvězd* :
                </td>
                <td class="info-table__value">
                  <v-text-field
                    :class="[
                      {
                        'input--error': reviewErrors.includes('review_rating'),
                      },
                    ]"
                    @input="removeErrorReview('review_rating')"
                    class="input--small"
                    outlined
                    type="number"
                    :min="0"
                    :max="5"
                    v-model="reviewData.rating"
                    @change="changeStars"
                  >
                  </v-text-field>
                </td>
              </tr>
              <tr>
                <td class="info-table__title" style="text-align: left">
                  Recenze z:
                </td>
                <td class="info-table__value">
                  <v-text-field
                    class="input--small"
                    outlined
                    v-model="reviewData.review_from"
                  >
                  </v-text-field>
                </td>
              </tr>
              <tr>
                <td class="info-table__title" style="text-align: left">
                  Datum recenze:
                </td>
                <td class="info-table__value">
                  <v-text-field
                    class="input--small"
                    outlined
                    v-model="reviewData.review_date"
                    type="date"
                  >
                  </v-text-field>
                </td>
              </tr>
              <tr>
                <td class="info-table__title" style="text-align: left">
                  Text:
                </td>
                <td class="info-table__value">
                  <v-textarea
                    class="input--small"
                    outlined
                    type="number"
                    v-model="reviewData.review"
                  >
                  </v-textarea>
                </td>
              </tr>
            </table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              class="button--dialog"
              @click="closeDialogReview()"
            >
              zrušit
            </v-btn>
            <v-btn
              v-if="reviewData.type == 'delete'"
              color="error"
              class="button--dialog"
              @click="deleteReview()"
            >
              smazat
            </v-btn>
            <v-btn
              v-if="reviewData.type == 'create'"
              color="primary"
              class="button--dialog"
              @click="createReview()"
            >
              přidat
            </v-btn>
            <v-btn
              v-if="reviewData.type == 'update'"
              color="primary"
              class="button--dialog"
              @click="updateReview()"
            >
              upravit
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline">Smazání audioknihy</v-card-title>
          <v-card-text>
            Opravdu si přejete smazat audioknihu <strong>{{ data.name }}</strong
            >?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              class="button--dialog"
              @click="closeDialogDelete()"
            >
              zrušit
            </v-btn>
            <v-btn
              color="error"
              class="button--dialog"
              @click="deleteAudiobook()"
            >
              smazat
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDatePreparing" persistent>
        <v-card>
          <v-card-title class="headline">Připravujeme datum </v-card-title>
          <v-date-picker
            v-model="data.preparing_date"
            locale="cs-cz"
            @click:date="closeDialogDatePreparing()"
          ></v-date-picker>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="empty"
              class="button--dialog"
              @click="closeDialogDatePreparing()"
            >
              zrušit
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDateFrom" persistent>
        <v-card>
          <v-card-title class="headline">Sleva platí od</v-card-title>
          <v-date-picker
            v-model="data.price_discount_from_date"
            locale="cs-cz"
            :max="data.price_discount_to_date"
          ></v-date-picker>
          <v-time-picker
            format="24hr"
            full-width
            header-color="primary"
            v-model="data.price_discount_from_time"
          ></v-time-picker>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="empty"
              class="button--dialog"
              @click="closeDialogDateFrom()"
            >
              zavřít
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogDateTo" persistent>
        <v-card>
          <v-card-title class="headline">Sleva platí do</v-card-title>
          <v-date-picker
            :min="data.price_discount_from_date"
            locale="cs-cz"
            v-model="data.price_discount_to_date"
          ></v-date-picker>
          <v-time-picker
            format="24hr"
            full-width
            header-color="primary"
            v-model="data.price_discount_to_time"
          ></v-time-picker>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="empty"
              class="button--dialog"
              @click="closeDialogDateTo()"
            >
              zavřít
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
  Image,
} from 'tiptap-vuetify';
import moment from 'moment';

export default {
  name: 'AudiobooksDetail',
  components: {
    TiptapVuetify,
  },

  data() {
    return {
      reviewErrors: [],
      langTypes: [
        {
          type: 'cs',
          text: 'Česky',
        },
        {
          type: 'sk',
          text: 'Slovensky',
        },
      ],
      reviewData: {},
      dialogReview: false,
      errorSet: '',
      errorCategories: '',
      orders: [],
      years: [],
      dialogDateFrom: false,
      dialogDateTo: false,
      extensions: [
        History,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [2, 3],
            },
          },
        ],
        Bold,
        Paragraph,
        HardBreak,
        Image,
      ],
      content: '',
      displayChapters: true,
      displayCategories: true,
      audioLength: 0,
      displaySets: true,
      categoryItem: {
        id: 0,
        name: 'Nevybráno',
      },
      exampleLongIsPlaying: false,
      audioExampleLong: null,
      exampleIsPlaying: false,
      audioExample: null,
      imageUploaded: true,
      exampleUpladed: true,
      exampleLongUpladed: true,
      dialogDelete: false,
      type: 'add',
      loaded: false,
      loadedList: false,
      data: {},
      dataList: {},
      errors: {},
      publishers: [],
      authors: [],
      interprets: [],
      categories: [],
      set_books: [],
      states: [],
      dialogDatePreparing: false,
      audiobooks: [],
      products: [],
      iosProductIds: [
        {
          ios_product_id: 'price_99_audiobook',
          price: '99',
        },
        {
          ios_product_id: 'price_149_audiobook',
          price: '149',
        },
        {
          ios_product_id: 'price_199_audiobook',
          price: '199',
        },
        {
          ios_product_id: 'price_249_audiobook',
          price: '249',
        },
        {
          ios_product_id: 'price_299_audiobook',
          price: '299',
        },
        {
          ios_product_id: 'price_349_audiobook',
          price: '349',
        },
        {
          ios_product_id: 'price_399_audiobook',
          price: '399',
        },
        {
          ios_product_id: 'price_449_audiobook',
          price: '449',
        },
        {
          ios_product_id: 'price_499_audiobook',
          price: '499',
        },
        {
          ios_product_id: 'price_599_audiobook',
          price: '599',
        },
        {
          ios_product_id: 'price_699_audiobook',
          price: '699',
        },
        {
          ios_product_id: 'price_799_audiobook',
          price: '799',
        },
        {
          ios_product_id: 'price_899_audiobook',
          price: '899',
        },
        {
          ios_product_id: 'price_999_audiobook',
          price: '999',
        },
        {
          ios_product_id: 'price_1049_audiobook',
          price: '1049',
        },
        {
          ios_product_id: 'price_1099_audiobook',
          price: '1099',
        },
        {
          ios_product_id: 'price_1149_audiobook',
          price: '1149',
        },
        {
          ios_product_id: 'price_1199_audiobook',
          price: '1199',
        },
        {
          ios_product_id: 'price_1249_audiobook',
          price: '1249',
        },
        {
          ios_product_id: 'price_1299_audiobook',
          price: '1299',
        },
        {
          ios_product_id: 'price_1349_audiobook',
          price: '1349',
        },
        {
          ios_product_id: 'price_1399_audiobook',
          price: '1399',
        },
        {
          ios_product_id: 'price_1449_audiobook',
          price: '1449',
        },
        // {
        //   ios_product_id: 'price_1499_audiobook',
        //   price: '1499',
        // },
      ],
      generateCopyRequest: false,
      isEbook: false,
      isBook: false,
      additionalFilesPath: null,
      additionoalFilesPresskitPath: null,
      additionalFilesPathFull: null,
      additionoalFilesPresskitPathFull: null,
      additionalFilesPathLoading: false,
      additionoalFilesPresskitPathLoading: false,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.audioExample) {
      this.audioExample.pause();
    }
    if (this.audioExampleLong) {
      this.audioExampleLong.pause();
    }

    this.exampleLongIsPlaying = false;
    this.audioExampleLong = null;
    this.exampleIsPlaying = false;
    this.audioExample = null;

    next();
  },

  created() {
    this.fetchDataLists();

    const vm = this;
    this.$root.$on('upload-audiobook-image', () => {
      vm.imageUploaded = false;
      vm.$forceUpdate();
    });
    this.$root.$on('upload-audiobook-example', () => {
      console.log('uploading-example');
      vm.exampleUpladed = false;
      vm.$forceUpdate();
    });
    this.$root.$on('upload-audiobook-example-long', () => {
      console.log('uploading-example-long');
      vm.exampleLongUpladed = false;
      vm.$forceUpdate();
    });

    this.$root.$on('uploaded-audiobook-image', (response) => {
      vm.data.image = response.url;
      vm.data.image_id = response.id;
      vm.imageUploaded = true;
      vm.$forceUpdate();
    });

    this.$root.$on('uploaded-audiobook-example', (response) => {
      vm.data.example_name = response.name;
      vm.data.example_url = response.url;
      vm.data.example_id = response.id;
      console.log('uploaded-example');
      vm.exampleUpladed = true;
      vm.$forceUpdate();
    });

    this.$root.$on('uploaded-audiobook-example-long', (response) => {
      vm.data.example_long_name = response.name;
      vm.data.example_long_url = response.url;
      vm.data.example_long_id = response.id;
      console.log('uploaded-example-long');
      vm.exampleLongUpladed = true;
      vm.$forceUpdate();
    });
  },
  computed: {
    ...mapState(['profile', 'files']),
    dateTo() {
      if (this.data.price_discount_to) {
        return moment(this.data.price_discount_to).format('DD.MM.YYYY HH:mm');
      } else {
        return null;
      }
    },
    dateFrom() {
      if (this.data.price_discount_from) {
        return moment(this.data.price_discount_from).format('DD.MM.YYYY HH:mm');
      } else {
        return null;
      }
    },
    datePreparing() {
      if (this.data.preparing_date) {
        return moment(this.data.preparing_date).format('DD.MM.YYYY');
      } else {
        return null;
      }
    },
  },
  mounted() {},
  methods: {
    toFloat(it, k) {
      if (it) {
        const fixed = parseFloat(it);
        this.data[k] = fixed.toFixed(2);
      }
    },
    async handleUploadAdditionalFiles(f, t = 'additionalFilesPath') {
      try {
        console.debug(f);
        this[`${t}Loading`] = true;
        let mf = new FormData();
        mf.append('file', f);
        const {
          data: { data: path },
        } = await this.$axios.post('admin/upload/additional', mf);
        console.debug(path);
        this[t] = path.path;
        this[`${t}Full`] = path.full_path;
        this.$refs.inputAdditionalFilesPresskit.value = '';
        this.$refs.inputAdditionalFiles.value = '';
        this[`${t}Loading`] = false;
      } catch (e) {
        console.error(e);
      }
    },
    removeErrorReview(t) {
      this.reviewErrors.splice(
        this.reviewErrors.findIndex((v) => v == t),
        1
      );
    },
    handleChangeToSet(e) {
      if (e.includes(9)) {
        this.isEbook = false;
        this.isBook = false;
      }
      this.$forceUpdate();
    },
    async generateAppCopy() {
      try {
        this.generateCopyRequest = false;
        console.debug('generate');
        await this.$axios.put(
          `admin/audiobooks/${this.$route.params.id}/generate`
        );
        this.data.prepared_status = 'not';
        this.generateCopyRequest = false;
      } catch (error) {
        console.error(error);
      }
    },
    changeStars() {
      if (isNaN(this.reviewData.rating)) {
        this.reviewData.rating = 0;
      } else if (parseFloat(this.reviewData.rating) > 5) {
        this.reviewData.rating = 5;
      }
    },
    openDialogReviewDelete(review) {
      this.reviewData = {
        id: review.id,
        name: review.name,
        nameOriginal: review.name,
        rating: review.rating,
        review: review.review,
      };
      this.reviewData.type = 'delete';
      this.dialogReview = true;
    },
    openDialogReviewUpdate(review) {
      this.reviewData = {
        id: review.id,
        name: review.name,
        nameOriginal: review.name,
        rating: review.rating,
        review: review.review,
        review_from: review.review_from,
        review_date: review.review_date,
      };
      this.reviewData.type = 'update';
      this.dialogReview = true;
    },
    openDialogReviewCreate() {
      this.reviewData = {};
      this.reviewData.type = 'create';
      this.dialogReview = true;
    },
    closeDialogReview() {
      this.dialogReview = false;
    },
    updateReview() {
      if (!this.reviewData.name) {
        this.reviewErrors.push('review_name');
      }
      if (!this.reviewData.rating) {
        this.reviewErrors.push('review_rating');
      }
      if (this.reviewErrors.length) return;
      this.dialogReview = false;
      this.loaded = false;
      const request = this.reviewData;
      this.$axios
        .put('/admin/audiobooks/' + this.data.id + '/reviews/update', request)
        .then((response) => {
          this.fetchReviews();
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    createReview() {
      if (!this.reviewData.name) {
        this.reviewErrors.push('review_name');
      }
      if (!this.reviewData.rating) {
        this.reviewErrors.push('review_rating');
      }
      if (this.reviewErrors.length) return;
      this.dialogReview = false;
      this.loaded = false;
      const request = this.reviewData;
      this.$axios
        .post('/admin/audiobooks/' + this.data.id + '/reviews/create', request)
        .then((response) => {
          this.fetchReviews();
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    deleteReview() {
      this.dialogReview = false;
      this.loaded = false;
      const request = this.reviewData;
      this.$axios
        .post('/admin/audiobooks/' + this.data.id + '/reviews/delete', request)
        .then((response) => {
          this.fetchReviews();
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    fetchReviews() {
      this.$axios
        .get('/admin/audiobooks/' + this.data.id + '/reviews')
        .then((response) => {
          this.data.reviews = response.data.reviews;
          this.loaded = true;
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    sumPrice(items) {
      var value = 0;
      items.forEach((item) => {
        value = value + parseFloat(item.price);
      });

      return value;
    },
    openDialogDateTo() {
      this.dialogDateTo = true;
    },
    closeDialogDateTo() {
      if (this.data.price_discount_to_date) {
        if (this.data.price_discount_to_time) {
          this.data.price_discount_to =
            moment(this.data.price_discount_to_date).format('YYYY-MM-DD') +
            ' ' +
            this.data.price_discount_to_time +
            ':00';
        } else {
          this.data.price_discount_to =
            moment(this.data.price_discount_to_date).format('YYYY-MM-DD') +
            ' ' +
            '00:00:00';
        }
      }
      this.dialogDateTo = false;
    },
    openDialogDateFrom() {
      this.dialogDateFrom = true;
    },
    openDialogDatePreparing() {
      this.dialogDatePreparing = true;
    },
    closeDialogDatePreparing() {
      this.dialogDatePreparing = false;
    },
    closeDialogDateFrom() {
      if (this.data.price_discount_from_date) {
        if (this.data.price_discount_from_time) {
          this.data.price_discount_from =
            moment(this.data.price_discount_from_date).format('YYYY-MM-DD') +
            ' ' +
            this.data.price_discount_from_time +
            ':00';
        } else {
          this.data.price_discount_from =
            moment(this.data.price_discount_from_date).format('YYYY-MM-DD') +
            ' ' +
            '00:00:00';
        }
      }
      this.dialogDateFrom = false;
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    setState(state) {
      if (state.checked) {
        this.data.states.push(state.id);
      } else {
        this.data.states = this.data.states.filter(
          (stateItem) => stateItem !== state.id
        );
      }
    },
    addCategory() {
      this.errorCategories = '';
      this.data.categories.push(null);
      this.$forceUpdate();
    },
    removeCategory(index) {
      this.displayCategories = false;
      this.data.categories.splice(index, 1);
      this.$forceUpdate();
      const vm = this;
      this.$nextTick(() => {
        vm.displayCategories = true;
      });
    },
    addSet() {
      this.errorSet = '';
      if (this.data.set_books.length < 6) {
        this.data.set_books.push(null);
        this.data.set_books_price.push({});
      }

      this.$forceUpdate();
    },
    removeSet(index) {
      this.errorSet = '';
      this.displaySets = false;
      this.data.set_books.splice(index, 1);
      this.data.set_books_price.splice(index, 1);
      this.$forceUpdate();
      const vm = this;
      this.$nextTick(() => {
        vm.displaySets = true;
      });
    },
    addChapter() {
      this.data.chapters.push(null);
      this.$forceUpdate();
    },
    removeChapter(index) {
      this.displayChapters = false;
      this.data.chapters.splice(index, 1);
      this.$forceUpdate();
      const vm = this;
      this.$nextTick(() => {
        vm.displayChapters = true;
      });
    },
    playPauseExample(audio) {
      if (this.audioExampleLong) {
        if (this.exampleLongIsPlaying) {
          this.exampleLongIsPlaying = false;
        }
        this.audioExampleLong.pause();
        this.audioExampleLong = null;
      }

      if (!this.audioExample) {
        this.audioExample = new Audio(audio);
      }
      if (this.exampleIsPlaying) {
        this.exampleIsPlaying = false;
        this.audioExample.pause();
      } else {
        this.exampleIsPlaying = true;
        this.audioExample.play();
      }
    },

    playPauseExampleLong(audio) {
      if (this.audioExample) {
        if (this.exampleIsPlaying) {
          this.exampleIsPlaying = false;
        }
        this.audioExample.pause();
        this.audioExample = null;
      }

      if (!this.audioExampleLong) {
        this.audioExampleLong = new Audio(audio);
      }
      if (this.exampleLongIsPlaying) {
        this.exampleLongIsPlaying = false;
        this.audioExampleLong.pause();
      } else {
        this.exampleLongIsPlaying = true;
        this.audioExampleLong.play();
      }
    },

    removeCoverImage() {
      this.data.image_id = null;
      this.data.image = null;
      this.$forceUpdate();
    },
    removeExample() {
      this.data.example_name = null;
      this.data.example_url = null;
      this.data.example_id = null;

      if (this.audioExample) {
        this.audioExample.pause();
      }
      this.exampleIsPlaying = false;
      this.audioExample = null;

      this.$forceUpdate();
    },
    removeExampleLong() {
      this.data.example_long_name = null;
      this.data.example_long_url = null;
      this.data.example_long_id = null;

      if (this.audioExampleLong) {
        this.audioExampleLong.pause();
      }
      this.exampleLongIsPlaying = false;
      this.audioExampleLong = null;

      this.$forceUpdate();
    },
    selectCoverImage() {
      this.$root.$emit('select-audiobook-image');
    },
    selectExample() {
      if (this.audioExample) {
        this.audioExample.pause();
      }
      this.exampleIsPlaying = false;
      this.audioExample = null;
      this.$root.$emit('select-audiobook-example');
    },
    selectExampleLong() {
      if (this.audioExampleLong) {
        this.audioExampleLong.pause();
      }
      this.exampleLongIsPlaying = false;
      this.audioExampleLong = null;
      this.$root.$emit('select-audiobook-example-long');
    },
    makeError(item) {
      if (item === 'required') {
        return 'Toto pole je povinné';
      } else if (item === 'already_used') {
        return 'Je již používaný';
      } else if (item === 'not_valid') {
        return 'Neplatný formát';
      } else if (item === 'not_number') {
        return 'Není číslo';
      } else if (item === 'bad_format') {
        return 'Špatný formát';
      } else if (item) {
        return 'Neznámá chyba';
      } else {
        return '';
      }
    },
    openDialogDelete() {
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.dialogDelete = false;
    },

    addAudiobook() {
      this.data.categories = Array.from(
        new Set(this.data.categories.filter((category) => category !== null))
      );
      this.data.set_books = Array.from(
        new Set(this.data.set_books.filter((set) => set !== null))
      );

      console.log(this.data.categories);
      if (this.data.categories.length === 0) {
        this.errorCategories = 'Musí být alespoň jedna kategorie.';
        return;
      }

      if (!this.data.lang) {
        this.errors.lang = 'required';
        this.$forceUpdate();
        return;
      }
      this.data.chapters = Array.from(
        new Set(this.data.chapters.filter((chapter) => chapter !== null))
      );
      if (
        this.data.states.find((state) => state === 9) &&
        this.data.set_books.length < 2
      ) {
        this.errorSet = 'Musí být alespoň dvě audioknihy v setu.';
        return;
      }
      if (this.data.price_discount_from) {
        this.data.price_discount_from = moment(
          this.data.price_discount_from
        ).unix();
      } else {
        this.data.price_discount_from = null;
      }
      if (this.data.price_discount_to) {
        this.data.price_discount_to = moment(
          this.data.price_discount_to
        ).unix();
      } else {
        this.data.price_discount_to = null;
      }
      this.loaded = false;

      this.data.is_ebook = this.isEbook;
      this.data.is_book = this.isBook;

      this.data.additional_files_path = this.additionalFilesPath;
      this.data.additional_files_presskit_path = this.additionoalFilesPresskitPath;

      const request = this.data;
      this.$axios
        .post('/admin/audiobooks/add', request)
        .then((response) => {
          this.$router.push({ name: 'Audiobooks' });
        })
        .catch((e) => {
          if (e.response.data.error_inputs) {
            this.errors = e.response.data.error_inputs;
          }
          this.loaded = true;
        });
    },
    editAudiobook() {
      this.data.categories = Array.from(
        new Set(this.data.categories.filter((category) => category !== null))
      );
      this.data.set_books = Array.from(
        new Set(this.data.set_books.filter((set) => set !== null))
      );

      if (this.data.categories.length === 0) {
        this.errorCategories = 'Musí být alespoň jedna kategorie.';
        return;
      }

      this.data.chapters = Array.from(
        new Set(this.data.chapters.filter((chapter) => chapter !== null))
      );
      if (
        this.data.states.find((state) => state === 9) &&
        this.data.set_books.length < 2
      ) {
        this.errorSet = 'Musí být alespoň dvě audioknihy v setu.';
        return;
      }

      if (this.data.price_discount_from) {
        this.data.price_discount_from = moment(
          this.data.price_discount_from
        ).unix();
      } else {
        this.data.price_discount_from = null;
      }
      if (this.data.price_discount_to) {
        this.data.price_discount_to = moment(
          this.data.price_discount_to
        ).unix();
      } else {
        this.data.price_discount_from = null;
      }

      this.loaded = false;
      this.data.is_ebook = this.isEbook;
      this.data.is_book = this.isBook;

      this.data.additional_files_path = this.additionalFilesPath;
      this.data.additional_files_presskit_path = this.additionoalFilesPresskitPath;

      const request = this.data;
      this.$axios
        .put('/admin/audiobooks/' + this.$route.params.id + '/edit', request)
        .then((response) => {
          this.$router.push({ name: 'Audiobooks' });
        })
        .catch((e) => {
          this.errors = e.response.data.error_inputs;
          this.loaded = true;
        });
    },
    deleteAudiobook() {
      this.loaded = false;
      const request = this.data;
      this.$axios
        .delete(
          '/admin/audiobooks/' + this.$route.params.id + '/delete',
          request
        )
        .then((response) => {
          this.$router.push({ name: 'Audiobooks' });
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    fetchData() {
      if (this.$route.params.id === 'add') {
        this.type = 'add';
        this.data = {};
        this.data.lang = 'cs';
        this.data.categories = [];
        this.data.set_books = [];
        this.data.set_books_price = [];
        this.data.chapters = [];
        this.data.states = [];
        this.data.is_book = false;
        this.data.is_ebook = false;
        this.data.additional_files_path = null;
        this.data.additional_files_presskit_path = null;
        this.$axios
          .get('/admin/audiobooks', {
            params: {
              sortBy: 'name', order: 'ASC',
              pagination: 0,
            },
          })
          .then((response) => {
            function sortComparer(a, b) {
              return a.name.localeCompare(b.name);
            }
            let audiobooks = response.data.audiobooks;
            audiobooks.sort(function(a, b) {
              return sortComparer(a, b);
            });

            this.audiobooks = audiobooks.filter(
              (v) => !v.is_book && !v.is_ebook
            );

            this.products = audiobooks;

            for (const p of this.products) {
              let name = p.name + ' (Audiokniha)';
              if (p.is_ebook) name = p.name + ' (E-kniha)';
              if (p.is_book) name = p.name + ' (Kniha)';
              p.name = name;
            }

            for (const audiobook of this.audiobooks) {
              audiobook.name = audiobook.name + ' (Audiokniha)';
            }

            this.loaded = true;
          })
          .catch((e) => {
            this.loaded = true;
          });
      } else {
        this.type = 'detail';
        this.$axios
          .get('/admin/audiobooks/' + this.$route.params.id)
          .then((response) => {
            this.orders = response.data.orders;
            function sortComparer(a, b) {
              return a.name.localeCompare(b.name);
            }
            let audiobooks = response.data.audiobooks;
            audiobooks.sort(function(a, b) {
              return sortComparer(a, b);
            });

            this.audiobooks = audiobooks.filter(
              (v) => !v.is_book && !v.is_ebook
            );

            for (const audiobook of this.audiobooks) {
              audiobook.name = audiobook.name + ' (Audiokniha)';
            }

            this.type = 'detail';

            this.data = response.data.audiobook;

            this.isEbook = this.data.is_ebook;
            this.isBook = this.data.is_book;
            this.additionalFilesPath = this.data.additional_files_path;
            this.additionalFilesPathFull = this.data.additional_files_full_path;
            this.additionoalFilesPresskitPath = this.data.additional_files_presskit_path;
            this.additionoalFilesPresskitPathFull = this.data.additional_files_presskit_full_path;

            if (this.data.price_discount_to) {
              this.data.price_discount_to = moment
                .unix(this.data.price_discount_to)
                .format('YYYY-MM-DD HH:mm:ss');
              this.data.price_discount_to_date = this.data.price_discount_to.split(
                ' '
              )[0];
              this.data.price_discount_to_time = this.data.price_discount_to.split(
                ' '
              )[1];
            }
            if (this.data.price_discount_from) {
              this.data.price_discount_from = moment
                .unix(this.data.price_discount_from)
                .format('YYYY-MM-DD HH:mm:ss');
              this.data.price_discount_from_date = this.data.price_discount_from.split(
                ' '
              )[0];
              this.data.price_discount_from_time = this.data.price_discount_from.split(
                ' '
              )[1];
            }

            var setBooksPrice = [];
            if (
              response.data.audiobook.set_books.length > 0 &&
              response.data.audiobook.set_books_price.length === 0
            ) {
              console.log('set-start');
              response.data.audiobook.set_books.forEach((item) => {
                setBooksPrice.push({
                  id: item,
                  price: response.data.audiobooks.find(
                    (audiobook) => audiobook.id === item
                  ).price,
                  price_eur: response.data.audiobooks.find(
                    (audiobook) => audiobook.id === item
                  ).price_eur,
                });
              });

              this.data.set_books_price = setBooksPrice;
              console.log('set', setBooksPrice);
            }
            // Podpora
            // this.recountSetData();

            var years = [];
            var year = null;
            response.data.orders.forEach((item) => {
              year = moment.unix(item.created_at).format('Y');
              if (!years.includes(year)) {
                years.push(year);
              }
              item.year = year;
            });

            this.years = years;
            console.log(years);
            console.log(response.data.orders);

            this.$forceUpdate();

            this.loaded = true;
          })
          .catch((e) => {
            this.loaded = true;
          });
      }
    },
    recountSetData() {
      if (this.data.set_books.length > 0) {
        var setBookSize = 0;
        var setBookSizeApi = 0;
        var setBookSizeLength = 0;
        this.data.set_books.forEach((item) => {
          const ab = this.audiobooks.find((a) => a.id === item);

          setBookSize += ab['size'];
          setBookSizeApi += ab['size_api'];
          setBookSizeLength += ab['length'];

          // setBookSize =
          //   setBookSize +
          //   this.audiobooks.find((audiobook) => audiobook.id === item).size;
          // setBookSizeApi =
          //   setBookSize +
          //   this.audiobooks.find((audiobook) => audiobook.id === item).size_api;
          // setBookSizeLength =
          //   setBookSize +
          //   this.audiobooks.find((audiobook) => audiobook.id === item).length;

          console.log({
            item: item,
            matched: ab['length'],
            setBookSizeLength,
          });
        });

        this.data.size = setBookSize;
        this.data.size_api = setBookSizeApi;
        this.data.length = setBookSizeLength;
      }
    },
    fetchDataLists() {
      this.$axios
        .get('/admin/audiobooks/data')
        .then((response) => {
          this.categories = response.data.categories;
          this.authors = response.data.authors;
          this.interprets = response.data.interprets;
          this.publishers = response.data.publishers;
          this.states = response.data.states;
          this.loadedList = true;

          this.fetchData();
        })
        .catch((e) => {
          this.loadedList = true;
        });
    },

    changeSetBook(index) {
      var audiobook = this.audiobooks.find(
        (audiobookItem) => audiobookItem.id === this.data.set_books[index]
      );

      if (audiobook) {
        this.data.set_books_price[index] = {
          id: audiobook.id,
          price: audiobook.price,
          price_eur: audiobook.price_eur,
        };
      }

      this.recountSetBookPrice();
    },

    recountSetBookPrice() {
      console.log('reset-price');
      var priceDiscount = 0;
      var price = 0;
      var priceDiscountEur = 0;
      var priceEur = 0;

      this.data.set_books_price.forEach((item) => {
        priceDiscount += parseFloat(item.price);
        priceDiscountEur += parseFloat(item.price_eur);
      });

      this.audiobooks
        .filter((item) => this.data.set_books.includes(item.id))
        .forEach((item) => {
          price += parseFloat(item.price);
          priceEur += parseFloat(item.price_eur);
        });

      if (price > priceDiscount) {
        if (!this.data.states.find((item) => item === 2)) {
          this.data.states.push(2);
        }
        this.data.price_discount = priceDiscount;
        this.data.price_discount_eur = priceDiscountEur;
      } else {
        this.data.price_discount = null;
        this.data.price_discount_eur = null;
        this.data.states = this.data.states.filter((item) => item !== 2);
      }
      console.log({ price, priceEur, priceDiscount, priceDiscountEur });
      this.data.price = price;
      this.data.price_eur = priceEur.toFixed(2);
      this.recountSetData();
      this.$forceUpdate();
    },
  },
  watch: {
    isEbook() {
      if (this.isEbook) {
        this.isBook = false;
        if (this.data.states.includes(9)) {
          this.data.states.splice(
            this.data.states.findIndex((v) => v == 9),
            1
          );
        }
      }
    },
    isBook() {
      if (this.isBook) {
        this.isEbook = false;
        if (this.data.states.includes(9)) {
          this.data.states.splice(
            this.data.states.findIndex((v) => v == 9),
            1
          );
        }
      }
    },
  },
};
</script>

<style lang="scss"></style>
